import type { TimelineRow } from '@tabel/shared/agent-events/timeline';
import { memo } from 'react';
import { MarkdownText } from '../markdown';

type Row = Extract<TimelineRow, { kind: 'assistant' }>;

/**
 * Курсор в конце ответа, пока агент пишет (мокап `.caret`): после последнего абзаца, без своей строки разметки —
 * абзацы не перерисовываются. При «уменьшить движение» — без мигания.
 */
const CARET =
  "[&>:last-child]:after:ml-0.5 [&>:last-child]:after:inline-block [&>:last-child]:after:h-4 [&>:last-child]:after:w-0.5 [&>:last-child]:after:animate-pulse [&>:last-child]:after:bg-ink-2 [&>:last-child]:after:align-[-3px] [&>:last-child]:after:content-[''] motion-reduce:[&>:last-child]:after:animate-none";

/**
 * Ответ агента (мокап `.a`): Markdown, растёт по мере вывода. Промежуточный текст работы агента (`interim`) — мельче и
 * серым (`.a.mid`).
 */
export const AssistantRow = memo(function AssistantRow({ row }: { row: Row }) {
  return (
    <div
      data-caret={row.streaming ? '' : undefined}
      className={`flex flex-col gap-2 leading-[1.5] break-words ${row.interim ? 'text-[13px] text-ink-2' : 'text-[14px] text-ink'} ${row.streaming ? CARET : ''}`}
    >
      <MarkdownText text={row.markdown} streaming={row.streaming} />
    </div>
  );
});
